<header>
  <div class="wrap">
    <div class="text">
      <h2 class="title">{{ 'popins.closet-doors-plinth-info.title' | translate }}</h2>
      <p class="my-5">{{ 'popins.closet-doors-plinth-info.p1' | translate }}</p>
    </div>
    <div class="header-actions">
      <button class="close" (click)="modalService.close()" title="{{ 'generic.close' | translate }}">
        <span class="icon-view-close" aria-hidden="true">
          <svg>
            <use xlink:href="assets/img/icons.svg#icon-view-close"></use>
          </svg>
        </span>
        <span>{{ 'generic.close' | translate }}</span>
      </button>
    </div>
  </div>
</header>
<div class="main">
  <footer class="popin-footer">
    <ng-casto-btn
      class="blue"
      [label]="'popins.closet-doors-plinth-info.confirm' | translate"
      (click)="modalService.close()"></ng-casto-btn>
  </footer>
</div>
